module.exports = __webpack_public_path__ + "static/1322712919.43d6344c.jpg";